import { type WorkflowsClientInterface } from './workflowsClient.types';
import LocalStorageWorkflowsClient from './localStorageWorkflowsClient';
import type { ClientContext } from '~/services/contextClient';

export default class WorkflowsClientFactory {
    static createClient(_context: ClientContext): WorkflowsClientInterface {
        // A single localStorage-backed fake serves every context today. The real
        // per-context HTTP client plugs in here later with no changes to the UI: it returns
        // the workflow JSON essentially as-is and each node component reads its own fields,
        // so no central transformer sits between the API and the canvas.
        return new LocalStorageWorkflowsClient();
    }
}
